import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.badge.borders.radius;
});
var spaces = css(["padding:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.components.badge.spaces.paddingHeight, " ").concat(theme.components.badge.spaces.paddingWidth);
});
var colors = css(["background-color:", ";color:", ";"], function (_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return theme.components.badge.colors.background[variant];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.badge.colors.text;
});
var fonts = css(["line-height:", ";font-size:", ";font-weight:", ";font-family:", ";letter-spacing:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.badge.fonts.lineHeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.badge.fonts.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.badge.fonts.fontWeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.badge.fonts.fontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.badge.fonts.letterSpacing;
});
var StyledBadge = styled.span(_templateObject(), borders, spaces, colors, fonts);

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Badge component.
 *
 */

var Badge = function Badge(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["children", "variant"]);

  return React.createElement(StyledBadge, _extends({
    variant: variant
  }, rest), children);
};

Badge.defaultProps = {
  variant: 'success'
};
Badge.propTypes = {
  /**
   * Content of the Badge.
   */
  children: PropTypes.node.isRequired,

  /**
   * Type of Badge.
   */
  variant: PropTypes.oneOf(['success', 'danger', 'info', 'warning'])
};
/** @component */

var index = styled(Badge)(_templateObject$1());

export default index;
